import { mapGetters, mapMutations, mapState } from "vuex";

export default {
	computed: {
		...mapState("wizard", ["index"]),

		...mapGetters({ device: "wizard/device" }),
	},

	methods: {
		...mapMutations({
			setBusy: "wizard/setBusy",
		}),

		async stop() {
			this.$log(
				`ZWave Wizard: Stop called on wizard step ${this.index} for ${this.device.path}`
			);

			this.setBusy(false);

			try {
				// clean up any pairing we were in the middle of
				let bridge = await this.getBridge();
				await bridge.child("commands/cancelAddRemove").execute();
			} catch (e) {
				console.error(e);
			}
		},

		async getBridge() {
			try {
				let k4 = await this.$store.dispatch("controller/getModel");
				let bridges = k4.model.classes["com.k4connect.zwave.bridge"];
				if (bridges && bridges.length > 0) {
					this.$log(`ZWave Wizard: Bridge located at ${bridges[0].path()}`);
					return bridges[0];
				}
			} catch (e) {
				console.error(e);
				await this.showError(
					"Unable to connect to the controller. Please check that it is online and try again."
				);
				throw e;
			}
		},
	},
};
